// Customers store price_band as a string code ("2"); products store
// price_bands[].band_code as a number (2). Both sides normalize to a trimmed
// string so numeric strings and numeric codes always match.
export function normalizeBandCode(value) {
    if (value === null || value === undefined) return null;
    const normalized = String(value).trim();
    return normalized === '' ? null : normalized;
}

const LIST_PRICE_BAND_CODE = '1';

function bandPrice(band) {
    return band && typeof band.price === 'number' && Number.isFinite(band.price) ? band.price : null;
}

function priceForBandCode(product, bandCode) {
    if (!bandCode || !product || !Array.isArray(product.price_bands)) return null;
    const band = product.price_bands.find(
        b => normalizeBandCode(b && b.band_code) === bandCode && bandPrice(b) !== null
    );
    return band ? bandPrice(band) : null;
}

// Resolution order for Sales Orders and external Job Sheets: the customer's
// band, then List Price (band 1, the approved fallback), then the first band
// carrying a valid numeric price. Always returns a finite number, never
// undefined, blank or NaN - 0 means "no usable price".
export function resolveProductUnitPrice(product, customerBand) {
    const fromCustomerBand = priceForBandCode(product, normalizeBandCode(customerBand));
    if (fromCustomerBand !== null) return fromCustomerBand;

    const listPrice = priceForBandCode(product, LIST_PRICE_BAND_CODE);
    if (listPrice !== null) return listPrice;

    if (product && Array.isArray(product.price_bands)) {
        const firstValid = product.price_bands.find(b => bandPrice(b) !== null);
        if (firstValid) return bandPrice(firstValid);
    }

    return 0;
}

// Internal job sheets always charge List Price regardless of the equipment
// customer's band - repair prices are adjusted manually.
export function resolveListPrice(product) {
    const listPrice = priceForBandCode(product, LIST_PRICE_BAND_CODE);
    return listPrice !== null ? listPrice : 0;
}

export function applySalesPrice(products, customerBand) {
    if (!Array.isArray(products)) return [];
    // Sales keeps null (not 0) for an unpriceable product: the picker renders
    // an em-dash and OrderItems.addProducts blocks the line, so a product
    // resolving to no usable price can never be sold at 0 by accident.
    return products.map(p => {
        const price = resolveProductUnitPrice(p, customerBand);
        return Object.assign({}, p, {
            cost_price: price > 0 ? price : null,
        });
    });
}
